module.exports = __webpack_public_path__ + "static/media/polygraph2-min.0bc448e7.jpeg";